import React from 'react'
import styled from "styled-components";
import Typewriter from "typewriter-effect";

 
const MyTitleMessage = styled.h1`
  position: absolute;
  width: 100%;
  top: 25rem;
  z-index: 1;
  margin-top: -125px;
  text-align: center;
  strong {
    font-size: 2.25em;
  }
  div {
    color: white;
    text-shadow: 0px 2px 5px rgba(255,255,255);
    font-weight: 100;
    letter-spacing: 7px;
    .main {
      font-size: 50px;
    }
    .sub {
      font-size: 27px;
      letter-spacing: 2px;
    }
  }
`;

const TitleMessage = () => (
  <MyTitleMessage>
    <div className="titleMessage">
      <div className="heading">
        <div className="main text-center mb-3">
          Hi, I am
          <br />
          <span>
            <strong>Muhammad Ahmed</strong>
          </span>
        </div>
        <div className="sub">
          <Typewriter
            options={{
              strings: ["Full Stack Developer", 
              "Front end Technology I am up for Is REACT", 
              "Also I've been working on python Django Framework"],
              autoStart: true,
              loop: true,
              delay: 50
            }}
          />
        </div>
      </div>
    </div>
  </MyTitleMessage>
);


export default TitleMessage